import React, { useMemo, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import toast from "react-hot-toast";
import { AiOutlineCheckCircle, AiOutlineEye } from "react-icons/ai";
import { useDispatch } from "react-redux";
import DataTable from "../../../../components/dataTable/dataTable";
import ProductModal from "../../../../components/modals/ProductModal";
import { getApprovedDisapprovedAgents } from "../../../../store/actions/agent.action";
import { AgentService } from "../../../../utils/services/agent.service";

import { approveAgentsDataTableConfig } from "../../../../utils/helpers/dataTableConfigs";

function Body({ domainBrand, agents = [] }) {
  const dispatch = useDispatch();
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const [filterValue, setFilterValue] = useState("");
  const [show, setShow] = useState(false);
  const [id, setId] = useState("");
  const [type, setType] = useState("");
  const [loading, setLoading] = useState(false);
  const [kyc, setKyc] = useState("");

  const actionColumn = {
    Header: () => {
      return <span className="text-center">Action</span>;
    },
    columnId: 7,
    accessor: "actions",
    Cell: ({ row }) => {
      return (
        <div className="text- pointer">
          <OverlayTrigger
            key={"1"}
            placement={"bottom"}
            overlay={<Tooltip id={`tooltip-${``}`}>Approve</Tooltip>}
          >
            <AiOutlineCheckCircle
              fontSize={18}
              color={"#6259CA"}
              onClick={() => {
                setShow(true);
                setId(row?.original?.agentId);
                setType("APPROVE-AGENT");
                setKyc(row?.original?.agentName);
              }}
            />
          </OverlayTrigger>
          &nbsp; &nbsp;
          <OverlayTrigger
            key={"2"}
            placement={"bottom"}
            overlay={<Tooltip id={`tooltip-${``}`}>View</Tooltip>}
          >
            <AiOutlineEye fontSize={22} color={"#6259CA"} />
          </OverlayTrigger>
        </div>
      );
    },
  };

  const approveAgentsDataTable = approveAgentsDataTableConfig(dictionary);
  const tableObject = [...approveAgentsDataTable, actionColumn];
  const columns = useMemo(() => tableObject, []);

  const handleActivation = async (id) => {
    setLoading(true);
    try {
      const response = await AgentService.approveAgentById(id);
      if (response.status === "SUCCESS") {
        toast.success("agent approved successfully");
        dispatch(getApprovedDisapprovedAgents());
        setLoading(false);
        setShow(false);
      } else {
        toast.error(response.message);
        setLoading(false);
        setShow(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <ProductModal
        show={show}
        handleClose={() => setShow(false)}
        handleActivation={() => handleActivation(id)}
        type={type}
        loading={loading}
        kyc={kyc}
      />

      <div className="app-content hor-content">
        <div className="container">
          <div className="page-header">
            <div>
              <h1 className="page-title">
                {dictionary ? dictionary["para_agents"] : "Agents"}
              </h1>
            </div>
          </div>

          <div className="row row-sm">
            <div className="col-lg-12">
              <div className="card overflow-hidden">
                <div className="card-header bg-primary text-white">
                  <h3 className="card-title">
                    {dictionary ? dictionary["l_all_agents"] : "All Agents"}
                  </h3>
                </div>
                <div className="card-body">
                  <div className="pb-5">
                    <p className="text-muted card-sub-title">
                      {dictionary
                        ? dictionary["WO_SORT_AND_FILTER_TABL_1070504595"]
                        : "Sort and filter table"}
                    </p>
                    <input
                      type={"text"}
                      value={filterValue}
                      onChange={(e) => setFilterValue(e.target.value)}
                      className="form-control w-50"
                    />
                  </div>
                  <div className="table-responsive ">
                    <DataTable
                      columns={columns}
                      data={agents}
                      filterData={filterValue}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Body;
